module.exports = __webpack_public_path__ + "img/12-min.e4e77d98.jpg";